import { Injectable } from '@angular/core';
import { HttpService } from './helpers/http.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ErrorService } from './helpers/error.service';
import { User } from '../models/models';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(private httpService: HttpService, private errorService: ErrorService) {}

  get(): Observable<User> {
    return this.httpService.sendGet('users/get').pipe(
      map((response) => {
        return this.errorService.processResponseForErrors(response);
      })
    );
  }

  search(
    lastName: string,
    firstName: string,
    middleName: string,
    organization: number,
    userId: number
  ) {
    return this.httpService
      .sendPost('users/search', {
        LastName: lastName,
        FirstName: firstName,
        MiddleName: middleName,
        Organization: organization,
        UserId: userId,
        page: 1,
        elementCount: 100,
      })
      .pipe(
        map((result) => {
          return result;
        })
      );
  }

  getActivityCount(userId: number): Observable<number> {
    return this.httpService.sendGet('users/get-activity-count?userId=' + userId)
      .pipe(map(response => {
        return this.errorService.processResponseForErrors(response);
      }));
  }
}
